export const LOCALES = ['es', 'ca', 'en'] as const
export type Locale = (typeof LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'es'

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
}

/** Picks the best supported locale from an Accept-Language style list. */
export function pickLocale(
  candidates: readonly string[],
  fallback: Locale = DEFAULT_LOCALE,
): Locale {
  for (const candidate of candidates) {
    const base = candidate.toLowerCase().split(/[-_]/)[0]
    if (isLocale(base)) return base
  }
  return fallback
}
